import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react'
import { fetchAuthSession } from 'aws-amplify/auth'
import { Text, Image, View, FlatList, TouchableOpacity, Keyboard, Modal, PixelRatio, ActivityIndicator } from 'react-native'
import {
    FormContentsModel,
    FormsModel,
    ModelAnswerFromProps,
    PerfectStoreTagsModel,
    StepsTypeModel,
    StoreAdditionalInfo,
} from './models/StoreDetailModel'
import { StoreFormItem } from './StoreFormItem'
import { StoreFormMV } from './StoreFormItem'
import { SiNoNaItem, SiNoNaSheet } from './FormItems/SiNoNaItem'
import { InputCommentItem } from './FormItems/InputCommentItem'
import { InputNumberItem } from './FormItems/InputNumberItem'
import { ScrollView } from 'react-native'
import styles from './ExecutionViewStyles'
import theme from '../../../theme'
import { Feather, Ionicons } from '@expo/vector-icons'
import { DropdownItem, DropdownMultipleSelectItem } from './FormItems/DropdownItem'
import { ImageFormItem } from './FormItems/ImageFormItem'
import { InputPhotoItem } from './FormItems/InputPhotoItem'
import { InputPriceNa, InputPriceSheet } from './FormItems/InputPriceNa'
import { StackScreenProps } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { useNavigation } from '@react-navigation/native'
import { schedulesServices } from '../../../database/schedules.database'
import { CHECKIN_STATUS, FORM_SCHEDULE_STATUS, FORM_TYPES, STATUS_FORM_PENDING_SYNC, STORE_STATUS } from './constants/constants.stores'
import { useFormContext } from './context/form.context'
import { getLanguage } from '../appBar/context/LocalizationContext'
import CameraView from '../customUtils/CameraView'
import { Loader } from '../customUtils/Components/Loader'
import { FormHorizontalTags } from './FormHorizontalTags'
import { InputButtonItem } from './FormItems/InputButtonItem'
import { InputFormItem } from './FormItems/InputFormItem'
import { InputCommentNoEditItem } from './FormItems/InputCommentNoEditItem'
import { useFormView } from './hooks/useFormView'
import { InputPhotoImageItem } from './FormItems/InputPhotoImageItem'
import { CampaignStatus } from './StatusTagsStores'
import { useModerationPeriodStore } from '../../redux/zustand/modarationPeriodStore'
import { useStoreStatusStore } from '../../redux/zustand/storesStatusStore'
import { getDateNow, isValidDateString, openExternalLink, validateConnectionNetwork } from '../../utils/functions.utils'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { request_save_form } from '../../services/schedule.services'

interface Props extends StackScreenProps<DotsNavigation, 'ExecutionView'> {}

const QUESTION_ID_CLOSE_MOTIVE = '0'
const OPTION_CLOSE = '1'
const OPTION_CLOSE_PERMANENTLY = '2'
const OPTION_CLOSE_OTHER = '3'

const FORM_ALIAS_STATUS = {
    SUCCESS: 1,
    DUPLICATED: -3,
    ERROR: -1,
}

const MESSAGES_FORM_ALIAS = {
    ERROR: 'Ocurrió un error al guardar tu elección. Por favor, intentá nuevamente.',
}

export const ExecutionView = React.memo(({ route }: Props) => {
    const { forms, selectedIndex, schedule_id, store_id, storeInfo, checkin_id, status_store, statusCheckin } = route.params

    const { languageFile } = getLanguage()
    const { formsContext, updateStatusForm, setReloadChange } = useFormContext()

    const [selectedForm, setForm] = useState<FormsModel>()
    const [formType, setFormType] = useState(0)
    const [formContent, setContents] = useState<FormContentsModel[]>([])
    const [reloadHideShowData, setReloadHideShowData] = useState(false)
    const [reloadForms, setReloadForms] = useState(false)
    const [iconSize, setIconSize] = useState(20)
    const [isFormReady, setIsFormReady] = useState(false)

    const fontScale = 1
    const allFilter = { _id: '-1', name: 'TODOS', isSelected: true }
    const allTags = [allFilter, ...(selectedForm?.tags ?? [])]
    const navigation = useNavigation()
    const { sendForm } = useFormView({
        form_id: selectedForm?._id,
        schedule_id,
        store_id,
        checkin_id,
    })

    useEffect(() => {
        if (fontScale > 1) {
            setIconSize(24) // Cambiar iconSize si el tamaño de la fuente es más grande
        } else {
            setIconSize(20) // Valor normal
        }

        onClickForm(selectedIndex)
    }, [])

    useEffect(() => {
        if (formContent.length > 0) {
            setIsFormReady(true)
        }
    }, [formContent])

    const onClickForm = useCallback(
        (index: number) => {
            try {
                if (formsContext.length > 0 && index !== -1) {
                    const repeat = formsContext[index].repeat
                    const status = formsContext[index].status
                    // console.log("65 -- 🚀 ~ onClickForm ~ status:", status)
                    const isFormRedirect = formsContext[index].type_form.type === FORM_TYPES.FORM_REDIRECT

                    if (
                        (status === FORM_SCHEDULE_STATUS.COMPLETED || status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION) &&
                        !repeat &&
                        !isFormRedirect
                    ) {
                        return () => {}
                    }
                } else {
                    index = 0
                }
            } catch (error) {
                console.error('71 ---- error: ', error)
            }

            if (selectedForm != null && selectedForm._id === forms[index]._id) {
                return
            }
            const type = forms[index]?.type_form?.type ?? 0

            if (type == FORM_TYPES.FORM_REDIRECT) {
                const url = forms[index]?.link
                const formRedirect = forms[index]
                const isValidUrl = url && /^https?:\/\/[\w.-]+\.[a-z]{2,}.*$/.test(url)
                if (!isValidUrl) {
                    console.log('URL inválida o no disponible:', url)
                    return
                }

                console.log('Navegando a WebViewScreen', url)
                const params = {
                    link: url,
                }
                updateStatusForm(formsContext, schedule_id, formRedirect._id, store_id, FORM_SCHEDULE_STATUS.PENDING_CONNECTION)
                setReloadChange()
                const sendForm = async () => {
                    const registerUpdated = await schedulesServices.updateStatusFormAnswerSchedule(
                        FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                        schedule_id,
                        formRedirect._id,
                        store_id,
                        'sin conexion',
                    )

                    await schedulesServices.updateStatusSendForm(
                        FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                        schedule_id,
                        formRedirect._id,
                        store_id,
                        'sin conexion',
                        registerUpdated.updatedId,
                    )
                }
                sendForm()
                // navigation.navigate('WebView', params as undefined)
                openExternalLink(url)
                return
            }

            let newContents = forms[index].contents.map((content) => ({
                ...content,
                hideQuestion: content.status === 3,
            }))

            setFormType(type)
            setContents(newContents ?? [])
            setForm(forms[index])
            // setIsFormReady(true)
        },
        [formsContext, forms, selectedForm],
    )

    const filterByTag = (tag: string, data?: FormContentsModel[]) => {
        console.log('🚀 ~ filterByTag ~ data:', data?.length)
        // console.log('🚀 ~ filterByTag ~ tag:', tag)
        let dataMap = data && data.length > 0 ? data : formContent
        let updatedFormContent = []
        if (tag != '-1') {
            updatedFormContent = dataMap.map((question) => {
                if (question.tag && question.tag._id != tag) {
                    return {
                        ...question,
                        hideByFilter: true,
                    }
                }
                return {
                    ...question,
                    hideByFilter: false,
                }
            })
        } else {
            updatedFormContent = dataMap.map((question) => {
                return {
                    ...question,
                    hideByFilter: false,
                }
            })
        }

        setContents(updatedFormContent)

        setReloadHideShowData(!reloadHideShowData)
    }
    const reloadFormsData = () => {
        setReloadForms(!reloadForms)
    }
    const getStatusForm = () => {
        if (selectedForm) {
            const formIndex = formsContext.findIndex((form) => form._id === selectedForm._id)
            // console.log("🚀 ~ getStatusForm ~ formIndex:", formIndex)

            const form = formsContext[formIndex]
            // console.log("🚀 ~ getStatusForm ~ form:", form)

            if (form) {
                return form.status
            }
        }
        return null
    }

    const RenderNoFormSelected = () => {
        return (
            <View style={styles.containerNoMessage}>
                <Image style={styles.imageNoMessage} source={require('../../../assets/noFormSelected.png')} />
                <Text style={styles.titleNoMessage}>{languageFile.select_form}</Text>
                <Text style={styles.descriptionNoMessage}>{languageFile.select_one_form}</Text>
            </View>
        )
    }

    const renderForm = useMemo(() => {
        if (formContent == undefined || formContent == null || formContent.length == 0) {
            return <RenderNoFormSelected />
        }

        let formData = formContent.sort((a, b) => a.index - b.index)

        switch (formType) {
            case FORM_TYPES.FORM_MODERACION:
            case FORM_TYPES.FORM_POP_HELADERA:
            case FORM_TYPES.FORM_IMAGE:
            case FORM_TYPES.FORMS:
                // return formContent.length > 0 && <FormView formContent={formContent} hideOrShow={hideOrShow} form_id={selectedForm?._id} />
                return (
                    <MemoizedFormView
                        key={selectedForm?._id}
                        formContent={formData}
                        form_id={selectedForm?._id}
                        schedule_id={schedule_id}
                        store_id={store_id}
                        repeat={selectedForm.repeat}
                        progress={selectedForm.progress}
                        totalScore={selectedForm.totalScore}
                        show_barcode={selectedForm.show_barcode || false}
                        hasFinishSheet={false}
                        reloadHideShowData={reloadHideShowData}
                        checkin_id={checkin_id}
                        tags={selectedForm?.tags?.length > 0 ? allTags : []}
                        // onClickTag={filterByTag}
                        name_form={selectedForm.name_form}
                        reloadFormsData={reloadFormsData}
                        formType={formType}
                        status_store={status_store}
                        statusCheckin={statusCheckin}
                        getStatusForm={getStatusForm}
                        formTypeObj={selectedForm.type_form}
                    />
                )

            default:
                return <RenderNoFormSelected />
        }
    }, [formType, formContent, selectedForm])

    return (
        <View style={styles.container}>
            {forms.length > 1 ? (
                <View>
                    {storeInfo && (
                        <>
                            <View style={styles.containerGeneral}>
                                <View style={styles.containerNameStore}>
                                    <Image
                                        style={[styles.storeImage, { width: iconSize, height: iconSize }]}
                                        source={require('../../../assets/stores/store.png')}
                                    />
                                    <Text style={styles.textNameStore}>{storeInfo.name}</Text>
                                </View>

                                {storeInfo.address && storeInfo.address != '-' && <Text style={styles.textAddressStore}>{storeInfo.address}</Text>}
                                <View style={[styles.flexDirectionRow, styles.marginHorizontal]}>
                                    {storeInfo.code && <Text style={styles.textCodeStore}>{storeInfo.code} </Text>}

                                    {storeInfo.additional && <AdditionalView additional={storeInfo.additional} />}

                                    <View style={styles.containerRow}>
                                        {storeInfo.cluster && <Text style={styles.textInfoStore}>| {storeInfo.cluster}</Text>}
                                        {storeInfo.distance && storeInfo.cluster && storeInfo.cluster.length < 15 && fontScale <= 1 && (
                                            <View style={styles.flexDirectionRow}>
                                                <Text style={styles.textInfoStore}> | </Text>
                                                <Feather
                                                    style={styles.marginRight}
                                                    name='map-pin'
                                                    size={iconSize}
                                                    color={theme.colors.textSecondary}
                                                />
                                                <Text style={styles.textInfoStore}>{storeInfo.distance}</Text>
                                            </View>
                                        )}
                                    </View>
                                </View>
                                {(storeInfo.distance && storeInfo.cluster && storeInfo.cluster.length >= 15) ||
                                    (fontScale > 1 && (
                                        <View style={[styles.flexDirectionRow, styles.marginHorizontal]}>
                                            <Feather style={styles.marginRight} name='map-pin' size={iconSize} color={theme.colors.textSecondary} />
                                            <Text style={styles.textInfoStore}>{storeInfo.distance}</Text>
                                        </View>
                                    ))}
                            </View>
                        </>
                    )}
                    <View style={styles.containerFilters}>
                        <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={styles.scrollView}>
                            <View style={styles.containerHorizontalTags}>
                                {forms
                                    // .filter((form) => form.type_form.type !== FORM_TYPES.FORM_REDIRECT) // Filtra los forms con type 43 (con link externo)
                                    .map((form, index) => {
                                        const isSelected = selectedForm === form
                                        const image = isSelected ? form?.icon_check : form?.icon

                                        return (
                                            <StoreFormItem
                                                key={form?._id + index}
                                                name={form?.name_form}
                                                image={image}
                                                index={index}
                                                onClickItem={onClickForm}
                                                isSelected={isSelected}
                                            />
                                        )
                                    })}
                            </View>
                        </ScrollView>
                    </View>
                </View>
            ) : (
                <View style={styles.containerFilters}>
                    {forms.map((form, index) => {
                        return <StoreFormMV key={form?._id + index} name={form?.name_form} />
                    })}
                </View>
            )}

            {/* {renderForm} */}
            {isFormReady ? renderForm : <ActivityIndicator size='large' color={theme.colors.colorPrimary} />}
        </View>
    )
})

export const AdditionalView = ({ additional }: { additional: StoreAdditionalInfo[] }) => {
    return (
        <View style={styles.flexDirectionRow}>
            {additional.map((item, index) => {
                if (item.label) {
                    switch (item.label) {
                        case 'segment':
                        case 'route':
                            return (
                                <Text key={item.id} style={styles.textCodeStore}>
                                    , {item.value}
                                </Text>
                            )
                        default:
                            return null
                    }
                }
            })}
        </View>
    )
}

interface FormViewProps {
    formContent: FormContentsModel[]
    hideOrShow?: (hide?: string[], show?: string[], data?: FormContentsModel[]) => void
    store_id?: string
    form_id?: string
    schedule_id?: string
    repeat?: boolean
    progress?: boolean
    totalScore?: number
    clearRegisterDatabaseLocal?: (type?: string) => void
    show_barcode?: boolean
    hasFinishSheet?: boolean
    reloadHideShowData?: boolean
    checkin_id?: string
    tags: PerfectStoreTagsModel[]
    onClickTag?: (id: string, data?: FormContentsModel[]) => void
    name_form?: string
    formType?: number
    reloadFormsData?: () => void
    actionButonSend?: (statusIncidence?: number, incidenteResponse?: string) => void
    title?: string
    status_store?: number
    statusCheckin?: number | undefined
    getStatusForm?: () => number | null
    formTypeObj: StepsTypeModel
    deleteForm?: ((a) => any) | undefined
}

export const FormView = ({
    formContent,
    hideOrShow,
    store_id,
    form_id,
    schedule_id,
    repeat,
    progress,
    totalScore,
    clearRegisterDatabaseLocal,
    show_barcode,
    hasFinishSheet,
    reloadHideShowData,
    checkin_id,
    tags,
    onClickTag,
    name_form,
    formType,
    reloadFormsData,
    actionButonSend = undefined,
    title,
    status_store,
    statusCheckin,
    getStatusForm,
    formTypeObj,
    deleteForm,
}: FormViewProps) => {
    const {
        isOpen,
        sendForm,
        sendFormsPending,
        reloadData,
        isLoadingReload,
        openBottomSheet,
        closeBottomSheet,
        setIsLoadingReload,
        setbuttonActive,
        buttonActive,
    } = useFormView({ checkin_id, clearRegisterDatabaseLocal, form_id, hasFinishSheet, reloadFormsData, schedule_id, store_id, title })

    const { formsContext, setFormsContext, setReloadChange, updateProgressForm, updateStatusForm, currentCheckin, updateStatusProgressForm } =
        useFormContext()
    const { languageFile } = getLanguage()
    const navigation = useNavigation()

    const isFormIncidence = formType == FORM_TYPES.FORM_INCIDENCE
    const isFormAlias = formType == FORM_TYPES.FORM_ALIAS

    const [data, setData] = useState([])
    const [answers, setAnswers] = useState([])
    const [isSending, setIsSending] = useState(false)
    const [keyboardHidden, setKeyboardHidden] = useState(true)
    const [activeInputId, setActiveInputId] = useState(null)
    const [isFirstLoad, setIsFirstLoad] = useState(true)
    const [messageFormByResponseRequest, setMessageFormByResponseRequest] = useState(null)
    const isSendingForm = useRef(false)

    const getStoreStatus = useStoreStatusStore((state) => state.getStoreStatus)
    const isUserBlocked = useModerationPeriodStore((state) => state.isUserBlocked)

    const initializeForm = () => {
        setData(formContent)
        checkCompleteInit()
    }
    let status_forms = FORM_SCHEDULE_STATUS.PENDING

    const createFormQuestionAnswer = useCallback(async () => {
        if (!formContent || formContent.length == 0) return
        try {
            const form_save = {
                schedule_id,
                form_id,
                store_id,
                repeat,
                questions: JSON.stringify(
                    formContent.map((question) => {
                        return {
                            _id: question._id,
                            title: question.title,
                            ponderar: question.questionScore && question.questionScore > 0, // [7, 8, 14, 18].includes(question.input_type.type),
                            questionScore: question.questionScore,
                            input_type: question.input_type,
                            secondary_actions: question.secondary_actions,
                            mandatory: question.mandatory,
                            score: question.score,
                        }
                    }) ?? '[]',
                ),
                progress,
                totalScore,
                // undefined,
                status: status_forms,
                name_form,
                heladera: null,
                create_refrigerator: null,
                type_form: formTypeObj,
                form_id_father: null,
            }

            await schedulesServices.saveFormAnswers(form_save)

            const form = {
                activity_id: form_id,
                status: status_forms,
                date: new Date().toISOString(),
                form_name: name_form,
                status_send: STATUS_FORM_PENDING_SYNC.NO_SENDED,
                schedule_id: schedule_id,
                count: 1,
                store_id: store_id,
                checkin_id: checkin_id,
            }

            await schedulesServices.addFormPendingSync(form)
        } catch (error) {
            console.error('Error en createFormQuestionAnswer:', error)
        }
    }, [formContent])

    useEffect(() => {
        createFormQuestionAnswer()
    }, [createFormQuestionAnswer])

    const checkStatusProgresForm = useCallback(async () => {
        try {
            const { progress_questions_yes_na, status } = await schedulesServices.getFormsAnswersInStore(schedule_id, form_id, store_id)

            // Ejecutar en paralelo
            updateStatusProgressForm(formsContext, schedule_id, form_id, store_id, status, progress_questions_yes_na)

            // await Promise.all([
            //     updateProgressForm(formsContext, schedule_id, form_id, store_id, progress_questions_yes_na),
            //     updateStatusForm(formsContext, schedule_id, form_id, store_id, status)
            // ])
        } catch (error) {
            console.error('Error en checkStatusProgresForm:', error)
        }
    }, [form_id, formContent, schedule_id, store_id])

    const checkCompleteInit = (): Promise<void> => {
        return new Promise((resolve, reject) => {
            schedulesServices
                .getFormsAnswersInStore(schedule_id, form_id, store_id, null, repeat)
                .then(({ fqa_id, answers, totalScore, scoreObtained, progress_questions_yes_na, status }) => {
                    // console.log('ejecuto siempre que entro a un form ?? => ', 'status =>', status, 'fqa_id => ', fqa_id)
                    setAnswers(answers)
                    const newFormContent = updateFormContent(formContent, answers)
                    updateProgressForm(formsContext, schedule_id, form_id, store_id, progress_questions_yes_na)
                    updateStatusForm(formsContext, schedule_id, form_id, store_id, status)
                    //ak calculo porcentaje y reviso boton

                    let completo = true
                    let totalResponse = answers.length
                    let totalQuestions = 0
                    newFormContent.forEach((item) => {
                        const isMandatory = item.mandatory !== false

                        if ((item.requiered || (true && item.status !== 3)) && isMandatory) {
                            let answerResponse = answers.find((answer) => answer._id === item._id)

                            if (answerResponse !== undefined) {
                                if (item.input_type.type === 14) {
                                    let secondarySelected = item.secondary_actions.find(
                                        (action) => action._id === answerResponse.option_selected_id[0],
                                    )

                                    secondarySelected.show_questions.forEach((question) => {
                                        let contesto = answers.find((answer) => answer._id === question)
                                        if (contesto == undefined) {
                                            completo = false
                                            //  console.log('falta responder esta...', item.title)
                                        } else {
                                            totalResponse--
                                        }
                                    })
                                }
                            } else {
                                //  console.log('falta responder esta...', item.title)
                                completo = false
                            }
                            //valido el type
                        }
                        if (item.status !== 3) {
                            totalQuestions++
                        }
                    })

                    const isAllQuestionsAreMandatoryFalse = verifyAllQuestionsAreMandatoryFalse(newFormContent)

                    if (isAllQuestionsAreMandatoryFalse) {
                        if (answers.length == 0) {
                            completo = false
                        }
                    }

                    if (completo) {
                        setbuttonActive(true)
                    } else {
                        //setbuttonActive(false)
                    }

                    let total = 0
                    for (let index = 0; index < newFormContent.length; index++) {
                        total += newFormContent[index].questionScore
                    }

                    let valor = 0

                    if (total > 0) {
                        valor = (scoreObtained * 100) / total
                    }
                    setData(newFormContent)

                    // console.log('🟨 305 ------------ checkComplete')
                    resolve()
                })
                .catch((error) => {
                    console.error(error)
                })
                .finally(() => {
                    setReloadChange()
                })
        })
    }

    const checkComplete = useCallback((option = null) => {
        let completo = true

        setMessageFormByResponseRequest(null)
        if (option) {
            setAnswers((prevAnswers) => {
                const exists = prevAnswers.some((item) => item._id === option._id)
                if (exists) {
                    return prevAnswers.map((item) => (item._id === option._id ? { ...item, ...option } : item))
                } else {
                    return [...prevAnswers, option]
                }
            })
        }

        return completo
    }, [])
    const handleInputFocus = (id) => {
        setActiveInputId(id) // Guardar el ID del TextInput que abrió el teclado
    }

    const validatedComplet = (data) => {
        let completo = true
        let totalResponse = data?.length
        let totalQuestions = 0
        let questions_filter = data.filter((item) => {
            if (!('hideQuestion' in item)) {
                return true
            }
            return item.hideQuestion != null && item.hideQuestion == false
        })
        questions_filter.forEach((item) => {
            const isMandatory = item.mandatory !== false
            if ((item.requiered || (true && item.status !== 3)) && isMandatory) {
                let answerResponse = answers.find((answer) => answer._id === item._id)

                if (answerResponse !== undefined) {
                    if (item.input_type.type === 14) {
                        let secondarySelected = item.secondary_actions.find((action) => action._id === answerResponse.option_selected_id[0])
                        if (secondarySelected?.show_questions && secondarySelected?.show_questions.length > 0) {
                            secondarySelected?.show_questions.forEach((question) => {
                                let contesto = answers.find((answer) => answer._id == question)
                                if (contesto == undefined) {
                                    // console.log('falta responder esta interna...', question)

                                    completo = false
                                } else {
                                    totalResponse--
                                }
                            })
                        } else {
                            totalResponse--
                        }
                    }
                } else {
                    completo = false
                }
                //valido el type
            }
            if (item.status !== 3) {
                totalQuestions++
            }
        })

        const isAllQuestionsAreMandatoryFalse = verifyAllQuestionsAreMandatoryFalse(questions_filter)

        if (isAllQuestionsAreMandatoryFalse) {
            if (answers.length == 0) {
                completo = false
            }
        }
        setbuttonActive(completo)
        if (completo) {
            setReloadChange()
        }
    }

    const verifyAllQuestionsAreMandatoryFalse = (questions) => {
        let allMandatoryFalse = true
        for (const question of questions) {
            if (question.mandatory == null || question.mandatory == undefined || question.mandatory === true) {
                allMandatoryFalse = false
                break
            }
        }
        return allMandatoryFalse
    }

    const isQuestionAllAnswered = async (
        questions: FormContentsModel[],
        schedule_id: string,
        form_id: string,
        store_id: string,
    ): Promise<boolean> => {
        let completo: boolean = true

        // si no tengo ninguna pregunta con mandatory false
        // no hace falta validar nada return true
        const isQuestionIncludeMandatoryFalse = questions.some((question) => question.mandatory === false)

        if (!isQuestionIncludeMandatoryFalse) {
            return completo
        }

        const { answers } = await schedulesServices.getFormsAnswersInStore(schedule_id, form_id, store_id)

        const cantAnswers = answers.length
        const cantQuestions = questions.length

        if (cantAnswers === cantQuestions) {
            return completo
        } else {
            completo = false
        }

        return completo
    }

    const confirmSendForm = async () => {
        try {
            let var_progress_questions_yes_na = null

            console.log('guardo en el local porque no hay conexion', schedule_id, form_id, store_id)

            const date_finish = getDateNow()

            const registerUpdated = await schedulesServices.updateStatusFormAnswerSchedule(
                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                schedule_id,
                form_id,
                store_id,
                'sin conexion',
            )

            await schedulesServices.updateStatusSendForm(
                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                schedule_id,
                form_id,
                store_id,
                'sin conexion',
                registerUpdated.updatedId,
                date_finish,
            )
            try {
                //actualizo el form adv
                if (form_id && form_id != '') {
                    const {
                        answers,
                        date_init,
                        date_finish,
                        progress_questions_yes_na,
                        heladera,
                        create_refrigerator,
                        type_form,
                        form_id_father,
                        scoreObtained,
                    } = await schedulesServices.getFormsAnswersInStore(schedule_id, form_id, store_id)
                    var_progress_questions_yes_na = progress_questions_yes_na
                    await schedulesServices.upsertFormStatus(schedule_id, form_id, 1, getDateNow(), progress_questions_yes_na, scoreObtained)
                }
            } catch (error) {}

            const index = formsContext.findIndex((form) => form._id.toString() == form_id.toString())

            if (index != -1) {
                const updatedForms = [...formsContext]
                updatedForms[index] = {
                    ...updatedForms[index],
                    status: FORM_SCHEDULE_STATUS.PENDING_CONNECTION, // Cambia el status aquí
                }

                setFormsContext(updatedForms)
                setReloadChange()
            }

            if (schedule_id && form_id && store_id && !isFormIncidence && !isFormAlias) {
                // console.log('envio fooorrrrm y actualizo adv~ schedule_id:', schedule_id)

                const result = await schedulesServices.upsertScheduleAdvanceLocal(
                    schedule_id,
                    store_id,
                    1,
                    new Date().toISOString(),
                    [{ _id: form_id, progress: var_progress_questions_yes_na, status: FORM_SCHEDULE_STATUS.PENDING_CONNECTION }],
                    [],
                )

                // console.log('result => ', result)
            } else {
                console.log('no guardo el adv falta datos, ', schedule_id, form_id, store_id, isFormIncidence)
            }

            let statusIncidence = null
            let incidenceAnswerText = null
            if (isFormIncidence === true) {
                const status = getStatusByReportSelected(answers)
                const incidenceResponse = getResponseIncidence(answers)

                statusIncidence = status
                incidenceAnswerText = incidenceResponse
            }

            if (actionButonSend != undefined) {
                console.log('estoyyy acaaaaa antes del goooo: ', statusIncidence)
                console.log('estoyyy acaaaaa antes del goooo: ', statusIncidence)
                actionButonSend(statusIncidence, incidenceAnswerText)
            } else {
                if (hasFinishSheet) {
                    console.log(' 1estoyyy acaaaaa antes del openFinishSheet')
                    openFinishSheet()
                    if (clearRegisterDatabaseLocal) {
                        setIsLoadingReload(true)
                        clearRegisterDatabaseLocal('pending')
                        // setbuttonActive(false)
                        setIsLoadingReload(false)
                    }
                } else {
                    console.log(' 2estoyyy acaaaaa antes del goBack')
                    navigation.goBack()
                }
            }
        } catch (error) {
            console.error('Error en confirmSendForm:', error)
            throw error
        } finally {
            // closeBottomSheet(true)
        }
    }

    const isFormSendNow = (formType: number): 0 | 1 => {
        // revisar que formularios necesitan enviarse ya o cuales pueden esperar
        // 1 envio ya, 0 envio despues

        const mapForms = {
            [FORM_TYPES.FORM_ALIAS]: 1,
            // [FORM_TYPES.FORM_INCIDENCE]: 1,
        }
        return (mapForms[formType] || 0) as 0 | 1
    }

    const getStatusByReportSelected = (answers: ModelAnswerFromProps[]): number => {
        if (!answers || answers.length == 0) return STORE_STATUS.INCIDENCE_REPORTED

        const answer = answers.find((answer) => answer.question_id == QUESTION_ID_CLOSE_MOTIVE)

        if (answer) {
            if (answer.option_selected_id.includes(OPTION_CLOSE_PERMANENTLY)) {
                return STORE_STATUS.INCIDENCE_REPORTED_PERMANENTE
            }
            if (answer.option_selected_id.includes(OPTION_CLOSE)) {
                return STORE_STATUS.INCIDENCE_REPORTED_CLOSE
            }
            return STORE_STATUS.INCIDENCE_REPORTED
        }
    }

    const getResponseIncidence = (answers: ModelAnswerFromProps[]) => {
        const RESPONSE_DEFAULT = 'Cliente cerrado'

        if (!answers || answers.length == 0) return 'Cliente cerrado'

        const answer = answers.find((answer) => answer.question_id == QUESTION_ID_CLOSE_MOTIVE)

        if (answer) {
            if (answer.option_selected_text && answer.option_selected_text.length > 0) {
                return answer.option_selected_text[0]
            }
        }

        return RESPONSE_DEFAULT
    }

    const handleSendFormNew = async () => {
        try {
            setAnswers([])
            if (messageFormByResponseRequest != null) {
                setMessageFormByResponseRequest(null)
            }
            const hasConnection = await validateConnectionNetwork()

            if (formType !== FORM_TYPES.FORM_POP_HELADERA) {
                const isCompletedForm = await isQuestionAllAnswered(formContent, schedule_id, form_id, store_id)

                if (!isCompletedForm) {
                    const title = '¿Estás seguro que deseas enviar?'
                    const description = 'Hay preguntas sin responder. Una vez enviado, no podrás completar este formulario nuevamente hasta mañana.'
                    const snapPoints = ['55%']

                    const buttonCancel = languageFile.cancel
                    const buttonConfirm = languageFile.confirm

                    const handleConfirmSendFormModal = async () => {
                        if (isSendingForm.current) {
                            console.error('Ya se está enviando el formulario, por favor espera.')
                            return
                        }
                        isSendingForm.current = true
                        await confirmSendForm()
                        isSendingForm.current = false
                        closeBottomSheet(true)
                    }

                    openBottomSheet(
                        <BottomSheetAlert
                            image={require('../../../assets/stores/checkOutLocked.png')}
                            title={title}
                            desc={description}
                            button={buttonCancel}
                            closeBottomSheet={closeBottomSheet}
                            buttonGoto={buttonConfirm}
                            goto={handleConfirmSendFormModal}
                        />,
                        snapPoints,
                    )
                } else {
                    const isSendNow = isFormSendNow(formType)

                    console.log('isSendNow, formType', isSendNow, formType)

                    if (isSendNow === 1) {
                        console.log('------------ enviar ahora------------ ')
                        if (hasConnection) {
                            await sendFormNow()
                        } else {
                            executeLoginByFormLostConnection(formType)
                        }
                    } else {
                        await confirmSendForm()
                    }
                }
            } else {
                // es de tipo heladera
                console.log(schedule_id)
                console.log(form_id)
                console.log(store_id)

                await schedulesServices.updateStatusFormAnswerSchedule(FORM_SCHEDULE_STATUS.COMPLETED, schedule_id, form_id, store_id)

                const index = formsContext.findIndex((form) => form._id.toString() === form_id.toString())

                if (index !== -1) {
                    const updatedForms = [...formsContext]

                    updatedForms[index] = {
                        ...updatedForms[index],
                        status: FORM_SCHEDULE_STATUS.COMPLETED, // Cambia el status aquí
                    }

                    setFormsContext(updatedForms)
                    setReloadChange()

                    navigation.goBack()
                }
            }
        } catch (error) {
            console.error('Error en handleSendFormNew:', error)
        } finally {
            Keyboard.dismiss()
        }
    }

    const sendFormNow = async () => {
        try {
            const { answers, date_init, date_finish, progress_questions_yes_na, heladera, create_refrigerator, type_form, scoreObtained } =
                await schedulesServices.getFormsAnswersInStore(schedule_id, form_id, store_id)

            let obj_json_raw = {
                answers: answers,
                date_finish: isValidDateString(date_finish) ? date_finish : date_init,
                date_init: date_init,
                id_activity: form_id,
                status: 0,
                progress: progress_questions_yes_na,
                score: scoreObtained,
                heladera: heladera,
                create_refrigerator: create_refrigerator,
                input_type: type_form ? type_form['type'] : null,
                refrigerator_id: '',
                store_id: store_id,
            }

            let json_raw = [obj_json_raw]

            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ""
            let dif_utc = -new Date().getTimezoneOffset() / 60

            const data = {
                authToken: authToken,
                body: {
                    form: JSON.stringify(json_raw),
                    process_now: true,
                    date: new Date().toISOString(),
                    schedule_id: schedule_id,
                    // checkin_id: validateStoreIdTypeIncidence ? store_id : (store_id && store_id != '') ? data_checkin_id : null,
                    dif_utc: dif_utc.toString(),
                },
            }

            const res = await request_save_form(data)

            executeLogicByFormType(formType, res)
        } catch (error) {
            console.error('sendFormNow Error ===>: ', error)
        }
    }

    const executeLogicByFormType = (formType, responseSaveForm) => {
        let status_send = responseSaveForm.status

        if (!status_send) {
            console.error('error al enviar form', form_id)
            return
        }

        if (formType === FORM_TYPES.FORM_ALIAS) {
            let data_alias = responseSaveForm?.response?.single?.data_alias
            status_send = responseSaveForm.status

            if (data_alias && data_alias.status === FORM_ALIAS_STATUS.ERROR) {
                console.error('error al enviar form', form_id, data_alias.message)
            }

            setbuttonActive(true)
            setMessageFormAlias(formType, data_alias)
            return
        }
    }

    const executeLoginByFormLostConnection = (formType) => {
        if (formType === FORM_TYPES.FORM_ALIAS) {
            const data_alias = {
                message: MESSAGES_FORM_ALIAS.ERROR,
                nickname: null,
                status: FORM_ALIAS_STATUS.ERROR,
            }

            setbuttonActive(true)
            setMessageFormAlias(formType, data_alias)
        }
    }

    const setMessageFormAlias = (formType, data_alias) => {
        if (formType === FORM_TYPES.FORM_ALIAS && data_alias != null) {
            // "message": "Alias confirmado \"Kenya Airways\"",
            //             "nickname": "Kenya Airways",
            //             "status": 1

            const message = data_alias?.message || null
            const nickname = data_alias?.nickname || null
            const status = data_alias?.status || null

            setMessageFormByResponseRequest(message)
            if (status === FORM_ALIAS_STATUS.SUCCESS) {
                deleteForm?.(nickname)
            } else {
                setbuttonActive(true)
            }
        }
    }

    const openFinishSheet = () => {
        openBottomSheet(<FinishSheet closeBottomSheet={closeBottomSheet} title={title ?? ''} />)
    }
    /**
     * @description agrego la key old_response en los contenidos depentiendo si tiene una respuesta guardada o no
     * @param formContents
     * @param responseGetFormsAnswers
     * @returns
     */
    const updateFormContent = (formContents: FormContentsModel[], responseGetFormsAnswers: ModelAnswerFromProps[]) => {
        try {
            const newFormContent = formContents.map((contenido) => {
                if (responseGetFormsAnswers.length > 0) {
                    // console.log('-------->>>>> estoy if en el old response')
                    const findIndex = responseGetFormsAnswers.findIndex((answer) => answer._id.toString() === contenido._id.toString())

                    if (findIndex !== -1) {
                        // lo encontre
                        return {
                            ...contenido,
                            old_response: responseGetFormsAnswers[findIndex],
                        }
                    } else {
                        if (contenido.old_response) {
                            const { old_response, ...contenidoSinOldResponse } = contenido

                            return contenidoSinOldResponse
                        } else {
                            return contenido
                        }
                    }
                } else {
                    //console.log('-------->>>>> estoy else en el old response')

                    if (contenido.old_response) {
                        //console.log('🚀 ~ newFormContent ~ old_response:', contenido.old_response)

                        const { old_response, ...contenidoSinOldResponse } = contenido

                        return contenidoSinOldResponse
                    } else {
                        return contenido
                    }
                }
            })

            return newFormContent
        } catch (error) {
            throw new Error('updateFormContent ERROR: ', error)
        }
    }
    const hideOrShowLocal = (hide?: string[], show?: string[], dataForm?: FormContentsModel[]) => {
        //console.log('Debería ocultar estos', hide)
        // console.log(data.length, 'Debería mostrar estos', show)
        let dataMap = dataForm && dataForm.length > 0 ? dataForm : data

        const updatedFormContent = data.map((question) => {
            if (hide.length > 0 && hide.includes(question._id)) {
                return {
                    ...question,
                    hideQuestion: true,
                }
            }
            if (show.length > 0 && show.includes(question._id)) {
                return {
                    ...question,
                    hideQuestion: false,
                }
            }
            return question
        })

        setData(updatedFormContent)
        //setReloadHideShowData(!reloadHideShowData)
    }

    const filterByTag = (tag: string) => {
        // console.log('🚀 ~ filterByTag ~ tag:', tag)
        //*
        let updatedFormContent = []

        if (tag != '-1') {
            updatedFormContent = data.map((question) => {
                if (question.tag && question.tag._id != tag) {
                    return {
                        ...question,
                        hideByFilter: true,
                    }
                }
                return {
                    ...question,
                    hideByFilter: false,
                }
            })
        } else {
            updatedFormContent = data.map((question) => {
                return {
                    ...question,
                    hideByFilter: false,
                }
            })
        }
        setData(updatedFormContent)
    }

    const returnBarCode = async (code: string) => {
        try {
            console.log('Codigo leido', code)
            const foundItem = formContent.findIndex((item) => item.description_short === code) // Test
            // const foundItem = formContent.findIndex((item) => item.code === code) //Real
            console.log('Item encontrado', foundItem)
            if (foundItem != -1) {
                setBarcodeActive(false)
                scrollToItem(foundItem)
            } else {
                setBarcodeActive(false)
                openBottomSheet(
                    <BarCodeErrorView
                        onPressRetry={() => {
                            closeBottomSheet(true)
                            canShowCamera()
                        }}
                    />,
                    ['45%'],
                )
            }
        } catch (error) {
            console.error('Error en returnBarCode:', error)
        }
    }
    const mainListRef = useRef(null)
    const [foundItemindex, setFoundItemIndex] = useState(-1)
    const scrollToItem = (index) => {
        closeBottomSheet(true)
        mainListRef.current?.scrollToIndex({ index: index, animated: true })
        setFoundItemIndex(index)
        setTimeout(() => setFoundItemIndex(-1), 1000)
    }
    const [barcode_active, setBarcodeActive] = useState(false)
    const canShowCamera = async () => {
        setBarcodeActive(true)
        // let title = languageFile.search_by_barcode
        // let desc = languageFile.scan_the_barcode

        // openBottomSheet(
        //     <>
        //         <CameraView
        //             closeBottomSheet={closeBottomSheet}
        //             returnedValue={(code: string) => returnBarCode(code)}
        //             title={title}
        //             description={desc}
        //             barcode={true}
        //         />
        //         <TouchableOpacity style={styles.paddingVertical} onPress={() => closeBottomSheet(true)}>
        //             <Text style={styles.floatingButtonText}>{languageFile.return_to_form}</Text>
        //             <View style={styles.horizontalLine}></View>
        //         </TouchableOpacity>
        //     </>,
        //     ['80%'],
        // )
        //returnBarCode('7791337007260') // => DASA
        // returnBarCode('6710017e37a5ecf8a4e887d6') // => id
    }
    const renderBarcodeCamera = () => {
        let title = languageFile.search_by_barcode
        let desc = languageFile.scan_the_barcode

        return (
            <Modal visible={barcode_active} animationType='slide'>
                <CameraView
                    closeBottomSheet={closeBottomSheet}
                    returnedValue={(code: string) => returnBarCode(code)}
                    title={title}
                    description={desc}
                    barcode={true}
                    closeCameraModal={() => setBarcodeActive(false)}
                />
                <TouchableOpacity style={styles.paddingVertical} onPress={() => setBarcodeActive(false)}>
                    <Text style={styles.floatingButtonText}>{languageFile.return_to_form}</Text>
                    <View style={styles.horizontalLine}></View>
                </TouchableOpacity>
            </Modal>
        )
        //returnBarCode('7791337007260') // => DASA
        // returnBarCode('6710017e37a5ecf8a4e887d6') // => id
    }
    const shouldShowButton = () => {
        const isNotFormImage = formType !== FORM_TYPES.FORM_IMAGE
        const isNotFormPopHeladera = formType !== FORM_TYPES.FORM_POP_HELADERA
        const isNotBlockedModerationForm = !(formType === FORM_TYPES.FORM_MODERACION && isUserBlocked())
        const isNotPendingModeration = store_id ? getStoreStatus(store_id) !== CampaignStatus.STATUS_FORM_PENDING_MODERATION : true
        const isNotPendingCheckin = statusCheckin !== undefined && store_id ? statusCheckin !== CHECKIN_STATUS.CHECKIN_PENDIENTE : true
        const isNotStatusForm = typeof getStatusForm === 'function' ? getStatusForm() !== CampaignStatus.STATUS_FORM_PENDING_MODERATION : true

        return (
            isNotFormImage && isNotFormPopHeladera && isNotBlockedModerationForm && isNotPendingModeration && isNotPendingCheckin && isNotStatusForm
        )
    }

    useEffect(() => {
        if (!isOpen && isFirstLoad) {
            initializeForm()
            setIsFirstLoad(false) // Para asegurarte de que solo se llama una vez
        }
    }, [isOpen])
    useEffect(() => {
        const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', () => {
            //console.log('estoy en el efect 11')
            setKeyboardHidden(true)
        })
        const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', () => setKeyboardHidden(false))
        return () => {
            keyboardDidHideListener.remove()
            keyboardDidShowListener.remove()
        }
    }, [])
    useEffect(() => {
        let values = data && data.length > 0 ? data : formContent
        validatedComplet(values)
        checkStatusProgresForm()
    }, [answers])

    useEffect(() => {
        setIsFirstLoad(true)
        setData(formContent)
        setTimeout(() => {
            setIsLoadingReload(false)
        }, 700)
    }, [reloadData])

    useEffect(() => {
        let dataRender = []
        // const newFormContents = updateFormContent(formContent, answers)
        if (data.length === 0) {
            dataRender = formContent
        } else {
            dataRender = data
        }
        const newFormContents = updateFormContent(dataRender, answers)
        // console.log('newFormContents', JSON.stringify(newFormContents))
        setData(newFormContents)
    }, [formContent, answers])
    //console.log('show', show_barcode)
    return (
        <>
            {isLoadingReload ? (
                <Loader />
            ) : (
                <View style={styles.container}>
                    <View style={styles.container}>
                        {show_barcode && <BarcodeButton canShowCamera={canShowCamera} />}

                        {tags && tags.length > 0 && (
                            <ScrollView style={styles.scrollView2} horizontal showsHorizontalScrollIndicator={false}>
                                <View style={styles.containerHorizontalTags}>
                                    <FormHorizontalTags tags={tags} data={data} onClickTag={filterByTag} />
                                    <View style={styles.spacer}></View>
                                </View>
                            </ScrollView>
                        )}

                        <View style={styles.spacerEight}></View>
                        <FlatList
                            ref={mainListRef}
                            data={data}
                            nestedScrollEnabled={true}
                            keyExtractor={(item, index) => (item?._id ? item._id.toString() + index.toString() : index.toString())}
                            horizontal={false}
                            showsVerticalScrollIndicator={false}
                            renderItem={({ item: item, index }) => (
                                <FormContentItem
                                    item={item}
                                    // hideOrShow={hideOrShow ? hideOrShow : hideOrShowLocal}
                                    hideOrShow={hideOrShowLocal}
                                    form_id={form_id}
                                    schedule_id={schedule_id}
                                    store_id={store_id}
                                    checkComplete={checkComplete}
                                    data={data}
                                    name_form={name_form}
                                    checkin_id={checkin_id}
                                    keyboardHiddenState={keyboardHidden}
                                    onFocus={(id) => handleInputFocus(id)}
                                    activeInputId={activeInputId}
                                    formType={formType}
                                    statusCheckin={statusCheckin}
                                    getStatusForm={getStatusForm}
                                    found={foundItemindex == index}
                                    key={item._id ? item._id.toString() + index.toString() : index.toString()}
                                />
                            )}
                            numColumns={1}
                        />
                        <View style={styles.spacerZero}></View>

                        <View style={styles.spacerZero}></View>
                    </View>

                    {messageFormByResponseRequest && (
                        <View style={{ flexDirection: 'row', alignItems: 'center', marginHorizontal: 15, width: '85%' }}>
                            <Ionicons name='close-sharp' size={24} color='red' />

                            <Text style={{ marginStart: 6, color: 'red', fontWeight: '400', fontSize: 15 }}>{messageFormByResponseRequest}</Text>
                        </View>
                    )}

                    {shouldShowButton() && (
                        <View style={styles.buttonContainer}>
                            <TouchableOpacity
                                onPress={() => handleSendFormNew()}
                                disabled={!buttonActive && !isSending}
                                style={[buttonActive && !isSending ? styles.mainButtonActive : styles.mainButton]}
                            >
                                <Text style={[buttonActive ? styles.mainButtonTextActive : styles.mainButtonText]}>{languageFile.send}</Text>
                            </TouchableOpacity>
                        </View>
                    )}
                    {barcode_active && renderBarcodeCamera()}
                </View>
            )}
        </>
    )
}

const MemoizedFormView = React.memo(FormView)

export const BarcodeButton = ({ canShowCamera }: { canShowCamera: () => void }) => {
    const { languageFile } = getLanguage()

    return (
        <>
            <View style={styles.spacerEight}></View>
            <TouchableOpacity onPress={() => canShowCamera()}>
                <View style={styles.floatingButton}>
                    <Text style={styles.floatingButtonText}>{languageFile.search_barcode}</Text>
                    <Image style={styles.floatingButtonIcon} source={require('../../../assets/stores/codebar.png')} />
                </View>
            </TouchableOpacity>
            <View style={styles.spacerEight}></View>
        </>
    )
}

export const BarCodeErrorView = ({ onPressRetry }: { onPressRetry: () => void }) => {
    const { languageFile } = getLanguage()

    return (
        <>
            <View style={styles.messageContainer}>
                <Image style={styles.imageAsset} source={require('../../../assets/barcodeNotFound.png')} />
                <Text style={styles.titleText}>{languageFile.product_not_found}</Text>
                <Text style={styles.descriptionText}>{languageFile.code_does_not_match}</Text>

                <View style={styles.buttonContainer}>
                    <TouchableOpacity style={styles.borderButton} onPress={onPressRetry}>
                        <Text style={styles.borderButtonText}>{languageFile.search_another_product}</Text>
                    </TouchableOpacity>
                </View>
            </View>
        </>
    )
}

export const FinishSheet = ({ closeBottomSheet, title }: { closeBottomSheet: (l) => void; title: string }) => {
    const { languageFile } = getLanguage()

    return (
        <>
            <View style={styles.messageContainer}>
                <Image style={styles.imageAsset} source={require('../../../assets/wiseFormSent.png')} />

                <Text style={styles.titleText}>{title ? `¡${title}${languageFile.form_submitted_successfully}` : ''}</Text>
                <Text style={styles.descriptionText}>{languageFile.send_new_survey}</Text>

                <View style={styles.buttonContainer}>
                    <TouchableOpacity style={styles.borderButton} onPress={() => closeBottomSheet(true)}>
                        <Text style={styles.borderButtonText}>{languageFile.accept}</Text>
                    </TouchableOpacity>
                </View>
            </View>
        </>
    )
}

interface FormContentItemProps {
    item: FormContentsModel
    form_id: string
    schedule_id: string
    store_id: string
    hideOrShow: (hides?: string[], show?: string[], data?: FormContentsModel[]) => void
    checkComplete: (option?: ModelAnswerFromProps) => void
    data: FormContentsModel[]
    name_form: string
    checkin_id: string
    keyboardHiddenState: boolean
    onFocus: (id: string) => void
    activeInputId: string
    formType: number
    statusCheckin?: number | undefined
    getStatusForm?: () => number | null
    found?: boolean
}

export const FormContentItem = React.memo(
    ({
        item,
        hideOrShow,
        form_id,
        schedule_id,
        store_id,
        checkComplete,
        data,
        name_form,
        checkin_id,
        keyboardHiddenState,
        onFocus,
        activeInputId,
        formType,
        statusCheckin,
        getStatusForm,
        found,
    }: FormContentItemProps) => {
        // console.log('1647 --- FormContentItem => ', item.input_type?.type)
        return (
            <View style={{ opacity: found ? 0.5 : 1 }}>
                {!item.hideQuestion && !item.hideByFilter ? (
                    <>
                        {(() => {
                            switch (item.input_type?.type) {
                                case 2:
                                    return <ImageFormItem item={item} />
                                case 4:
                                    return (
                                        <InputPhotoItem
                                            item={item}
                                            hasCamera={true}
                                            hasGalery={true}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                        />
                                    )
                                case 5:
                                    return (
                                        <InputCommentItem
                                            item={item}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                            keyboardHiddenState={keyboardHiddenState}
                                            onFocus={onFocus}
                                            activeInputId={activeInputId}
                                        />
                                    )

                                case 7:
                                case 8:
                                case 14:
                                case 18:
                                    return (
                                        <SiNoNaItem
                                            item={item}
                                            hideOrShow={hideOrShow}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                            data={data}
                                            name_form={name_form}
                                            keyboardHiddenState={keyboardHiddenState}
                                            onFocus={onFocus}
                                            activeInputId={activeInputId}
                                        />
                                    )

                                case 9:
                                    return (
                                        <InputNumberItem
                                            item={item}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                            name_form={name_form}
                                            keyboardHiddenState={keyboardHiddenState}
                                            onFocus={onFocus}
                                            activeInputId={activeInputId}
                                        />
                                    )

                                case 10:
                                case 36:
                                    return (
                                        <DropdownItem
                                            item={item}
                                            hideOrShow={hideOrShow}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                            data={data}
                                        />
                                    ) //Dropdown
                                case 11:
                                    return (
                                        <DropdownMultipleSelectItem
                                            item={item}
                                            hideOrShow={hideOrShow}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                        />
                                    ) //DropdownMultipleSelect

                                case 16:
                                    return (
                                        <InputButtonItem
                                            item={item}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                        />
                                    ) // Heladera
                                case 21:
                                    return (
                                        <InputPriceNa
                                            item={item}
                                            name_form={name_form}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                            keyboardHiddenState={keyboardHiddenState}
                                            onFocus={onFocus}
                                            activeInputId={activeInputId}
                                        />
                                    )
                                case 32: // foto sin galeria
                                    return (
                                        <InputPhotoItem
                                            item={item}
                                            hasCamera={true}
                                            hasGalery={false}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                        />
                                    )

                                case 33: // foto sin camara
                                    return (
                                        <InputPhotoItem
                                            item={item}
                                            hasCamera={false}
                                            hasGalery={true}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                        />
                                    )

                                case 37:
                                    return (
                                        <InputFormItem
                                            item={item}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                            checkin_id={checkin_id}
                                        />
                                    )
                                case 38:
                                    return (
                                        <InputCommentNoEditItem
                                            item={item}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                        />
                                    )
                                case 41:
                                    return (
                                        <InputPhotoImageItem
                                            item={item}
                                            hasCamera={true}
                                            hasGalery={true}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            checkComplete={checkComplete}
                                            formType={formType}
                                            statusCheckin={statusCheckin}
                                            getStatusForm={getStatusForm}
                                        />
                                    )
                                default:
                                    return <Text>{item.title} item not found</Text>
                            }
                        })()}
                    </>
                ) : (
                    <></>
                )}
            </View>
        )
    },
)
